<template lang="html">

  <div 
    v-if="cell"
    :class="[staticClasses, cellClass]"
    @click="onClick"
    :style="`animation-delay: ${ animationDelay }s`"
  >
    <svg 
      viewbox="0 0 100 100"
      v-show="isPlaying || completed"
    >
      <text
        x="50%"
        y="50%"
        dy=".4em"
      >
        {{ displayValue }}
      </text>
    </svg>    

    <div class="sup">
      {{ cell.clueNumber }}
    </div>

  </div>

</template>

<script lang="js">

  import { mapGetters, mapState, mapActions } from 'vuex'

  import { debounce } from 'throttle-debounce'

  export default  {
    name: 'cell',
    props: [
      'row',
      'col',
    ],

    mounted () {
      this.cell = this.getCellAtPosition(this.row, this.col)
    },

    data() {
      return {
        cell: null,
        debouncedClasses: '',
      }
    },

    methods: {
      ...mapActions({
        selectCell: 'grid/selectCell',
        toggleIsAcross: 'grid/toggleIsAcross',
        // selectCluesByCell: 'cluelist/selectCluesByCell',
      }),
      
      onClick(e) {
        if (this.cell.isBlack || this.cell.given) return

        this.selectCell({
          row: this.row, 
          col: this.col,
        })
      },

      isSelected() {
        return this.selectedCell === this.cell
      },

      isSameNumber() {
        return this.selectedCell && this.selectedCell.clueNumber === this.cell.clueNumber
      },

      animate() {},
      
      isIncorrect() {
        return !this.cell.isCorrect() &&
               this.gameMode === 'quick' &&
               !this.cell.given &&
               this.visualGuides
      },

      isCorrect(){
        var ret = false
        
        if(!this.isBlack())
        {
            if(this.gameMode === 'quick' && this.visualGuides)
            {
              if(this.cell.isCorrect())
                ret = true
            }
        }
        return ret;
        /*return  &&
                &&
               !this.cell.given &&
                &&
               this.isBlack*/
      },
      
      isFilled() {
        if (this.gameMode !== 'quick') // only use in challenge mode 
          return this.cell.input !== 0
        else
          return false
      },
      
      isBlack(){
        return this.cell.isBlack
      },

      isWordCorrect() {                
        if (this.gameMode !== 'quick' || !this.visualGuides) return
        let across = this.getClueByWord(this.cell.words.across)
        let down = this.getClueByWord(this.cell.words.down)

        if (!across && !down) return false          
      
        let acrossCorrect = across && across.isWordCorrect()
        let downCorrect   = down && down.isWordCorrect()

        return (acrossCorrect || downCorrect)      
      },

      isWordSelected() {
        if (!this.selectedCell) return false
        let dir = this.isAcross ? 'across' : 'down'
        return this.selectedCell.words[dir] === this.cell.words[dir]
      },

      setDebouncedClasses() {

      },
    },

    computed: {
      ...mapGetters({
        getCellAtPosition: 'grid/getCellAtPosition',
        selectedCell: 'grid/getSelectedCell',
        rows: 'grid/getRows',
        cols: 'grid/getCols',
        getClueByWord: 'cluelist/getClueByWord',
        noNeighbouringCells: 'grid/noNeighbouringCells',
      }),
      
      ...mapState({
        cells: state => state.grid.cells,
        solution: state => state.grid.solution,
        gameMode: state => state.userSettings.gameMode,
        visualGuides: state => state.userSettings.visualGuides,
        isPlaying: state => state.game.isPlaying,
        gameType: state => state.game.type,
        completed: state => state.game.completed,
        clues: state => state.cluelist.clues, 
        isAcross: state => state.grid.isAcross, 
      }),

      // TODO make sure these only emit once per user input
      cellClass() {
        return {
          'pe_selected': this.isSelected(),
          'pe_is-same-number': this.isSameNumber(),
          'pe_is-incorrect': this.isIncorrect(),
          'pe_is-filled': this.isFilled(),
          'pe_is-correct': this.isCorrect(),
        }
      },

      staticClasses() {
        return {
          'pe_cell': true,
          'pe_is-given': this.cell.given,
          'pe_is-black': this.cell.isBlack,
        }
      },

      displayValue() {
        if (this.cell.given)
          return this.cell.solution
        else if (this.cell.input !== 0) 
          return this.cell.input
        else
          return ''
      },

      animationDelay() {
        if (!this.selectedCell) return
        
        let absRow = Math.abs(this.selectedCell.row - this.row)
        let absCol = Math.abs(this.selectedCell.col - this.col)

        return ((absRow + absCol) * 0.04 ).toFixed(2)
      },

    }
  }

</script>



<style scoped lang="scss">
  // TODO move css to a singular cell class file

  @import '@puzzleapps/shared/src/style/variables';
  @import '@puzzleapps/shared/src/style/animations';

  .pe_cell {
    display: flex;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
    transform: translateZ(0);
    flex-grow: 1;
    flex-basis: 0;
    align-items: center;
    justify-content: center;
    font-size: 1.7em;
    font-family: $pen-font;
    user-select: none;    
    color: var(--pencil-color);
    box-shadow: inset 1px 1px var(--thin-border-color);
    transition: background 0.07s;
    font-weight: 400;
    z-index: 5;
    overflow: hidden;
    box-shadow: inset 1px 1px #0f1113;
    color: #0f1113;

    svg {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0%;
      left: 0;

      text {        
        font-family: $pen-font;
        // font-size: 60px;
        text-anchor: middle;
      }
    }

    .sup {
      display: flex;
      position: absolute;
      width: 33.33333%;
      height: 33.33333%;    
      align-items: center;
      justify-content: center;
      left: 0;
      top: 0;
      font-size: 1.1rem;
      margin-top: 1.6%;
      color: var(--pencil-color);      
      font-family: $primary-font;
      font-size: 0.7rem;
      font-weight: 500;
      justify-content: left;
      margin-left: 0.1rem;
      // margin-top: -0.05rem;
      color: #0f1113;

      @media screen and (max-width: 600px) {
        margin: 0;
        left: 0.1em;
        top: 0.3em;
        opacity: 0.6;
      }

      &:nth-of-type(3n + 2) {
        left: 33.33333%;
      }

      &:nth-of-type(3n + 3) {
        left: 66.66666%;
      }

      &:nth-of-type(n + 4) {
        top: 33.33333%;
      }

      &:nth-of-type(n + 7) {
        top: 66.66666%;
      }

    }

    @media screen and (max-width: 800px) {
      font-size: 3.4vw;
    }

    @media screen and (max-width: 600px) {
      font-size: 5.7vw;
    }

    &:hover {
      background: var(--primary-hover);
    }

    &:before {
      content: "";
      display: block;
      padding-bottom: 100%;
    }

    &:after {
      z-index: 9;
    }

    
    &.is-filled {
      
      sup {
        display: none;
      }
    }

    &.is-given {
      background: #dfdbdb;
      cursor: default;

      svg text {        
        font-family: $pen-font!important;
      }
      sup {
        display: none;
      }
    }

    &.pe_is-black {
      background: #0c0c0c;
      cursor: default;
    }

    &.pe_is-incorrect svg text {
      fill: rgb(199, 48, 48);
    }

    &.pe_is-incorrect{
      background-color: #fff;
    }

    &.pe_is-same-number {
      background: var(--codecracker-cell-same-as-selected);
    }

    &.pe_is-correct{
      background-color: #9ddc9d;
    }

    &.pe_is-given{
      background-color: #9ddc9d;
      font-weight: 700;
    }

    &.pe_is-filled{
      background-color: #dddddd;
    }


    // &.word-correct.selected-word {
    //   animation-name: correct;
    //   animation-duration: 0.6s;
    //   animation-timing-function: cubic-bezier(0,.5,1,.5);
    // }

    // &.pe_is-same-number {
    //   background: lighten(var(--cell-selected-group-color), 5%);
    // }

    // &.pe_selected {
    //   background: darken(var(--primary-color), 15%);
    // }

    @keyframes correct {
      50% {background-color: #9ddc9d}
    }
  }
</style>

